export default "__VITE_ASSET__1EbYUSRh__"